import {Button, Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import DynamicCustomSelectorV2 from "../../FormPage/DynamicCustomSelectorV2";
import BaseSelectorV2 from "../../../Common/Component/Select/BaseSelectorV2";
import HttpRequest from "../../../Common/Http/HttpRequest";
import {diffHorasSegundos, HourMinuteSeg} from "../../../Common/Utils/DateFormat";
import Notify from "../../../Common/Notify/Notify";

const currentDate = new Date();
const MESES = [
    {label: 'Janeiro', id: 0, date: new Date(currentDate.getFullYear(), 0, 1, 0, 0, 0)},
    {label: 'Fevereiro', id: 1, date: new Date(currentDate.getFullYear(), 1, 1, 0, 0, 0)},
    {label: 'Março', id: 2, date: new Date(currentDate.getFullYear(), 2, 1, 0, 0, 0)},
    {label: 'Abril', id: 3, date: new Date(currentDate.getFullYear(), 3, 1, 0, 0, 0)},
    {label: 'Maio', id: 4, date: new Date(currentDate.getFullYear(), 4, 1, 0, 0, 0)},
    {label: 'Junho', id: 5, date: new Date(currentDate.getFullYear(), 5, 1, 0, 0, 0)},
    {label: 'Julho', id: 6, date: new Date(currentDate.getFullYear(), 6, 1, 0, 0, 0)},
    {label: 'Agosto', id: 7, date: new Date(currentDate.getFullYear(), 7, 1, 0, 0, 0)},
    {label: 'Setembro', id: 8, date: new Date(currentDate.getFullYear(), 8, 1, 0, 0, 0)},
    {label: 'Outubro', id: 9, date: new Date(currentDate.getFullYear(), 9, 1, 0, 0, 0)},
    {label: 'Novembro', id: 10, date: new Date(currentDate.getFullYear(), 10, 1, 0, 0, 0)},
    {label: 'Dezembro', id: 11, date: new Date(currentDate.getFullYear(), 11, 1, 0, 0, 0)},
]

const weekday = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sabado"];

export const ExportarHorasDiretaMes = () => {

    const [mes, setMes] = useState(MESES[0])
    const [projetos, setProjetos] = useState(null);


    const exportData = () => {

        const fimMes = new Date(mes.date.getFullYear(), mes.date.getMonth() + 1, 0, 23, 59, 59);
        HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}/crud/entity/cflow_work_times?size=9000&startTime_gt=${mes.date.toISOString()}&endDate_lt=${fimMes.toISOString()}`)
            .then(response => {
                console.log('Data: ', response.data);

                const lines = [`${mes.label};Dia;Start;End;Total;Projeto;Anotação`];

                response.data.forEach(element => {
                    const startDate = new Date(element.startTime);
                    const endDate = element.endDate ? new Date(element.endDate) : new Date();
                    const project = element.project.name;
                    const detalhes = element.descriptionStart + ' -- ' + element.descriptionOnFinish

                    const date = startDate.getDate();
                    const diaSemana = weekday[startDate.getDay()];

                    const tempoTotal = diffHorasSegundos(endDate, startDate);
                    const line = `${diaSemana};${date};${HourMinuteSeg(startDate)};${HourMinuteSeg(endDate)};${tempoTotal};${project};${detalhes}`.replace(/\n/g, '  /  ');
                    lines.push(line);
                })

                if (lines.length === 1) {
                    Notify.warning('Sem dados para exportar');
                    return;
                }


                const csvConteudo = lines.join('\n');
                const blob = new Blob([csvConteudo], {type: 'text/csv;'});
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.download = 'Horas ' + mes.label + '.csv';
                document.body.appendChild(link);
                link.click();


            });
    }

    useEffect(() => {
    }, [])

    return (
        <>
            <hr/>
            <Row>
                <Col>
                    <DynamicCustomSelectorV2
                        title="Projeto(s)"
                        showCreateButton={false}
                        isMulti={true}
                        entitySchema="cflow_projects"
                        value={projetos}
                        setValue={setProjetos}/>
                </Col>
                <Col>
                    <BaseSelectorV2
                        title="Mes"
                        showCreateButton={false}
                        items={MESES}
                        label="label"
                        rowId="id"
                        value={mes}
                        setValue={setMes}/>
                </Col>
                <Col>

                    <Button className="mt-4" onClick={exportData}>Exportar</Button>
                </Col>

            </Row>
            <hr/>
        </>
    )
}
